import { useMemo } from 'react'

import { Loader2 } from 'lucide-react'

import { formatters } from '@Components/hierarchical-report/Layout'
import HierarchicalTable from '@Components/hierarchical-report/Table'

import { buildMetricColumn } from '../utils/metricColumns'
import { useCustomReportStore } from '../store'

function normalizeTableData(data) {
  if (!data) return { children: [] }
  if (Array.isArray(data)) return { children: data }
  if (data.children) return data
  return { children: [data] }
}

function TableResult({ data, metrics = [], groupby = [], collection }) {
  const tableData = useMemo(() => normalizeTableData(data), [data])

  const columns = useMemo(() => {
    const metricKeys = metrics.map(metric => (typeof metric === 'string' ? metric : metric.key))

    return [
      {
        dataField: 'value',
        text: groupby?.length ? groupby.join(' / ') : 'Name',
        customSort: true,
        sortValue: row => row.name || row.keyString || row.value,
        formatter: formatters.name,
      },
      ...metricKeys.map(key => buildMetricColumn(key, collection)),
    ]
  }, [metrics, groupby, collection])

  if (!tableData.children?.length) {
    return <div className="font-semibold py-8 text-center">No results to show.</div>
  }

  return <HierarchicalTable columns={columns} data={tableData} />
}

export default function ReportTable() {
  const {
    config: { value: config },
    table: { data, status },
  } = useCustomReportStore()

  if (status === 'loading') {
    return (
      <div className="flex justify-center items-center h-40">
        <Loader2 size={24} className="animate-spin" />
      </div>
    )
  }

  if (status === 'error') {
    return null
  }

  return (
    <TableResult
      data={data}
      metrics={config.metrics}
      groupby={config.groupby}
      collection={config.collection}
    />
  )
}
